import { z, ZodIssueCode } from 'zod';
import type { I18nValidationNs } from './dictionaries/interfaces.ts';

const defaultMessage = nameof.full<I18nValidationNs>((n) => n.fieldInvalid);
const requiredMessage = nameof.full<I18nValidationNs>((n) => n.fieldRequired);

export default function initZodLocale() {
  z.setErrorMap((issue) => {
    if (issue.message) {
      return { message: issue.message };
    }

    if (issue.code === ZodIssueCode.invalid_type && issue.received === 'undefined') {
      return { message: requiredMessage };
    }

    return { message: defaultMessage };
  });
}
